import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditPromoCodeDiscount = (props) => {
  return (
    <Edit
      title='Edit Promo Code Discount'
      fields={fields}
      apiPath={`admin/promo_code_discounts/${props.params.promoCodeDiscountId}`}
      successRedirectPath='/ecommerce/promo-code-discounts'
      buildMenuItems={menuItems}
    />
  )
}

export default EditPromoCodeDiscount
